module.exports = __webpack_public_path__ + "img/discussion-downvote.150499ce.svg";